<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<h4>Alert Details</h4>

				<div>
					<!--Table-->
					<div class="table-main-body">
						<p-table
							#mydt
							[value]="lstScanAlert"
							[loading]="loading"
							[paginator]="true"
							[(rows)]="pagerows"
							[(first)]="pagefirst"
							[showCurrentPageReport]="true"
							[resizableColumns]="false"
							sortMode="multiple"
							styleClass="p-datatable-striped"
							selectionMode="single"
							[(selection)]="SelectedScanAlert"
							dataKey="Scan_AlertID"
							(onFilter)="onHandleFilter($event)"
							(onSort)="onHandleSort($event)"
							(onRowSelect)="onRowSelect($event)"
							(onRowUnselect)="onRowUnselect($event)"
							currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
							[rowsPerPageOptions]="[5, 10, 25, 50]"
						>
							<!--Headers-->
							<ng-template pTemplate="header">
								<!--Filter or Select from Dropdown-->
								<tr>
									<!--INSERT CUSTOM FILTERS HERE-->

									<!--AlertOrder-->
									<th>
										<p-columnFilter type="text" field="AlertOrder" matchMode="contains" [showMenu]="true"></p-columnFilter>
									</th>

									<!--IncidentDT-->
									<th>
										<!-- <p-columnFilter type="text" field="IncidentDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
									</th>

									<!--InfractionDesc-->
									<th>
										<p-columnFilter field="InfractionDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterInfractionDesc
													[ngModel]="value"
													[options]="lstInfractionDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--ContinueAlertDesc-->
									<th>
										<p-columnFilter field="ContinueAlertDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterContinueAlertDesc
													[ngModel]="value"
													[options]="lstContinueAlertDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--WeaponTypeDesc-->
									<th>
										<p-columnFilter field="WeaponTypeDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterWeaponTypeDesc
													[ngModel]="value"
													[options]="lstWeaponTypeDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--PenaltyDesc-->
									<th>
										<p-columnFilter field="PenaltyDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterPenaltyDesc
													[ngModel]="value"
													[options]="lstPenaltyDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--GroupActionDesc-->
									<th>
										<p-columnFilter field="GroupActionDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterGroupActionDesc
													[ngModel]="value"
													[options]="lstGroupActionDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--GroupDesc-->
									<th>
										<p-columnFilter type="text" field="GroupDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
									</th>

									<!--AlertDesc-->
									<th>
										<p-columnFilter type="text" field="AlertDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
									</th>

									<!--AlertTypeDesc-->
									<th>
										<p-columnFilter field="AlertTypeDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterAlertTypeDesc
													[ngModel]="value"
													[options]="lstAlertTypeDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--AlertSeverityDesc-->
									<th>
										<p-columnFilter field="AlertSeverityDesc" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterAlertSeverityDesc
													[ngModel]="value"
													[options]="lstAlertSeverityDesc"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>

									<!--Message-->
									<th>
										<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
									</th>

									<!--Priority-->
									<th>
										<p-columnFilter field="Priority" matchMode="equals" [showMenu]="false">
											<ng-template pTemplate="filter" let-value let-filter="filterCallback">
												<p-dropdown
													#filterPriority
													[ngModel]="value"
													[options]="lstPriority"
													(onChange)="filter($event.value)"
													placeholder="Any"
													[showClear]="true"
												>
													<ng-template let-value pTemplate="item">
														<span>{{ value }}</span>
													</ng-template>
												</p-dropdown>
											</ng-template>
										</p-columnFilter>
									</th>
								</tr>

								<!--Column Names-->
								<tr style="height: 4rem">
									<!--INSERT CUSTOM COLUMNS HERE-->
									<th pSortableColumn="AlertOrder">Alert Order<p-sortIcon field="AlertOrder"></p-sortIcon></th>
									<th pSortableColumn="IncidentDT">Incident Date<p-sortIcon field="IncidentDT"></p-sortIcon></th>
									<th pSortableColumn="InfractionDesc">Infraction<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
									<th pSortableColumn="ContinueAlertDesc">Continue Alert<p-sortIcon field="ContinueAlertDesc"></p-sortIcon></th>
									<th pSortableColumn="WeaponTypeDesc">Weapon Type<p-sortIcon field="WeaponTypeDesc"></p-sortIcon></th>
									<th pSortableColumn="PenaltyDesc">Penalty<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
									<th pSortableColumn="GroupActionDesc">Part of Group Action<p-sortIcon field="GroupActionDesc"></p-sortIcon></th>
									<th pSortableColumn="GroupDesc">Group<p-sortIcon field="GroupDesc"></p-sortIcon></th>
									<th pSortableColumn="AlertDesc">Alert<p-sortIcon field="AlertDesc"></p-sortIcon></th>
									<th pSortableColumn="AlertTypeDesc">Alert Type<p-sortIcon field="AlertTypeDesc"></p-sortIcon></th>
									<th pSortableColumn="AlertSeverityDesc">Alert Severity<p-sortIcon field="AlertSeverityDesc"></p-sortIcon></th>
									<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
									<th pSortableColumn="Priority">Priority<p-sortIcon field="Priority"></p-sortIcon></th>
								</tr>
							</ng-template>

							<!--Data-->
							<ng-template pTemplate="body" let-ScanAlert>
								<tr [pSelectableRow]="ScanAlert">
									<td *ngFor="let col of cols" style="font-weight: bold">
										{{ ScanAlert[col.field] }}
									</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
